import axiosInstanceForTemplate from './axiosInstanceForTemplate';

export const allTemplates = async (params) => {
	try {
		const res = await axiosInstanceForTemplate.get(`/search`, {
			params,
			data: null
		});
		return res;
	} catch (error) {
		return error.response.data;
	}
};
